import { useMemo } from 'react'
import { useVisibilityConditionSearchByPlacementIdQuery } from 'domains/banners/api'

interface VisibilityConditionsByPlacementIdArgs {
  placementId: string
}

export const useVisibilityConditionsSearch = ({
  placementId,
}: VisibilityConditionsByPlacementIdArgs) => {
  const { data, error, loading, refetch } = useVisibilityConditionSearchByPlacementIdQuery({
    fetchPolicy: 'cache-and-network',
    variables: { placementId },
  })

  const visibilityConditions = useMemo(() => {
    if (data?.visibilityConditionSearch?.length) {
      const conditions = data.visibilityConditionSearch
      return conditions
    } else {
      return []
    }
  }, [data])

  return {
    visibilityConditions,
    searchVisibilityConditionsByPlacementId: refetch,
    apiResult: data?.visibilityConditionSearch,
    apiSuccess: Boolean(data),
    apiLoading: loading,
    apiError: error,
  }
}
